import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, formatNumber } from '@angular/common';
import { getCurrencyCode } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'FortressCurrencyPipe' })
export class FortressCurrencyPipe implements PipeTransform {
  private currenyCode: string = getCurrencyCode();

  constructor(
    private currencyPipe: CurrencyPipe,
    private translate: TranslateService
  ) {}

  transform(value: any, currencyCode?: string, display?: string, digitsInfo?: string, locale?: string) {
    if (currencyCode && currencyCode === 'PTS') {
      value = formatNumber(value, 'en-GB', '1.0-0');
      return value + ' ' + this.translate.instant('fgbcl.currency.pts');
    } else {
      const displayInCurrency = currencyCode ? display : 'symbol-narrow';
      const code = currencyCode ?? this.currenyCode;
      return this.currencyPipe.transform(value, code, displayInCurrency, digitsInfo, locale);
    }
  }
}
